export default from './CookiesPolicy';



// WEBPACK FOOTER //
// ./fe/web-career/src/js/components/CookiesPolicy/index.js